import { render, staticRenderFns } from "./PotentialWorkerTag.vue?vue&type=template&id=4fc3d7f1&"
import script from "./PotentialWorkerTag.vue?vue&type=script&lang=js&"
export * from "./PotentialWorkerTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports